<template>
    <span>
        <svg-icon :width="width" :height="height" :viewBox="`0 0 ${height} ${width}`" iconName="search">
            <defs>
                <path id="7bcxlxrn9a" d="M15.565 5.984C14.285 4.704 12.584 4 10.775 4c-1.81 0-3.511.705-4.79 1.984C4.704 7.264 4 8.964 4 10.774s.705 3.511 1.984 4.79c1.28 1.28 2.98 1.985 4.79 1.985s3.511-.705 4.79-1.984c1.28-1.28 1.985-2.981 1.985-4.79 0-1.81-.705-3.511-1.984-4.79zm-4.79 10.272c-3.023 0-5.482-2.459-5.482-5.482 0-3.022 2.459-5.481 5.481-5.481 3.023 0 5.482 2.459 5.482 5.481 0 3.023-2.459 5.482-5.482 5.482zm9.036 2.64l-4.25-4.248c-.252-.253-.66-.253-.913 0-.252.252-.252.662 0 .914l4.249 4.249c.126.126.291.189.457.189.165 0 .33-.063.457-.19.252-.252.252-.66 0-.913z"/>
            </defs>
            <g fill="none" fill-rule="evenodd">
                <mask id="ayb95ibipb" fill="#fff">
                    <use xlink:href="#7bcxlxrn9a"/>
                </mask>
                <g class="path" :fill="fill" mask="url(#ayb95ibipb)">
                    <path :d="`M0 0H${height}V${width}H0z`"/>
                </g>
            </g>
        </svg-icon>
    </span>
</template>

<script>
import SvgIcon from '@theme-views/common/SvgIcon'

export default {
    name: 'svg-search',
    computed: {
        fill() {
            return this.color || 'url(#linearGradient-1)'
        }
    },
    components: {
        SvgIcon
    },
    props: {
        width: {
            type: Number,
            default: 26,
        },
        height: {
            type: Number,
            default: 26,
        },
        color: {
            type: String,
            default: null
        }
    },
}
</script>